module.exports = __webpack_public_path__ + "img/logo.32e2eb69.png";